// src/services/travel/busService.ts
import axios from "axios";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/v1/travel/buses`;

export const getBuses = () => axios.get(BASE_URL);
export const createBus = (data: any) => axios.post(BASE_URL, data);
export const updateBus = (id: string, data: any) =>
  axios.put(`${BASE_URL}/${id}`, data);
export const deleteBus = (id: string) => axios.delete(`${BASE_URL}/${id}`);
